import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "./Button";

function getHeaders() {
	const token = localStorage.getItem("token");
	return token ? { Authorization: `Bearer ${token}` } : {};
}

function EditUniverseDialog({ open, onClose, universe, onUpdated }) {
	const [name, setName] = useState("");
	const [description, setDescription] = useState("");
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [error, setError] = useState("");

	useEffect(() => {
		if (open && universe) {
			setName(universe.name || "");
			setDescription(universe.description || "");
			setError("");
		}
	}, [open, universe]);

	const handleSubmit = useCallback(async () => {
		setIsSubmitting(true);
		setError("");
		try {
			const res = await fetch(`/v1/admin/universes/${universe.universeId}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json", ...getHeaders() },
				body: JSON.stringify({ name: name.trim() || null, description: description.trim() || null }),
			});
			if (res.ok) {
				if (onUpdated) onUpdated();
				onClose();
			} else {
				setError(await res.text());
			}
		} catch { setError("Errore di connessione"); }
		finally { setIsSubmitting(false); }
	}, [universe, name, description, onUpdated, onClose]);

	if (!open || !universe) return null;

	return (
		<dialog open className="fixed inset-0 z-[100] flex items-center justify-center w-screen h-screen m-0 max-w-none max-h-none border-0 bg-slate-900/60 backdrop-blur-sm backdrop-filter p-4" aria-modal="true" onCancel={onClose}>
			<div className="w-full max-w-lg rounded-xl border border-slate-200 bg-white shadow-2xl overflow-hidden">
				<div className="border-b border-slate-200 px-5 py-4">
					<h2 className="text-lg font-semibold text-slate-900">Edit Universe</h2>
					<p className="mt-1 text-sm text-slate-600">
						<span className="font-mono text-xs text-slate-500">{universe.universeId}</span>
					</p>
				</div>

				<div className="space-y-4 px-5 py-4">
					<div>
						<label htmlFor="eu-name" className="block text-sm font-medium text-slate-700">Name</label>
						<input id="eu-name" type="text" value={name} onChange={(e) => setName(e.target.value)}
							className="mt-1 block w-full rounded-md border border-slate-300 px-3 py-2 text-sm shadow-sm focus:border-blue-500" />
					</div>
					<div>
						<label htmlFor="eu-description" className="block text-sm font-medium text-slate-700">Description</label>
						<textarea id="eu-description" value={description} onChange={(e) => setDescription(e.target.value)}
							rows={3}
							className="mt-1 block w-full rounded-md border border-slate-300 px-3 py-2 text-sm shadow-sm focus:border-blue-500" />
					</div>
					{error && <div className="rounded-md bg-red-50 p-3 text-sm text-red-600">{error}</div>}
				</div>

				<div className="flex justify-end gap-2 border-t border-slate-200 bg-slate-50 px-5 py-3">
					<Button variant="outline" onClick={onClose} disabled={isSubmitting}>Cancel</Button>
					<Button onClick={handleSubmit} disabled={isSubmitting}>{isSubmitting ? "Saving..." : "Save"}</Button>
				</div>
			</div>
		</dialog>
	);
}

EditUniverseDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	universe: PropTypes.object,
	onUpdated: PropTypes.func,
};

export default EditUniverseDialog;
